package com.icebyte.printprofiletracker

import kotlinx.browser.window
import kotlinx.coroutines.await
import org.w3c.dom.Element
import org.w3c.dom.Document
import org.w3c.dom.parsing.DOMParser
import kotlin.js.Date

actual fun openUrl(url: String) {
    try {
        window.open(url, "_blank")
    } catch (_: Throwable) {
        // ignore
    }
}

actual suspend fun fetchThreeMfSummary(url: String): String? {
    try {
        val response = window.fetch(url, js("({ method: 'GET' })")).await()
        if (!response.ok) return null
        val text = response.text().await() as String
        val trimmed = text.trimStart()
        if (!trimmed.startsWith("<?xml")) {
            return null // binary/zip - cannot parse here
        }
        val parser = DOMParser()
        val doc = parser.parseFromString(text, "application/xml") as Document
        val objects = (doc.getElementsByTagName("object")?.length ?: 0)
        val modelNodes = doc.getElementsByTagName("model")
        val unit = if (modelNodes != null && modelNodes.length > 0) {
            val el = modelNodes.item(0) as? Element
            el?.getAttribute("unit") ?: "unspecified"
        } else {
            "unspecified"
        }
        // collect metadata entries
        val metadataNodes = doc.getElementsByTagName("metadata")
        val metaList = mutableListOf<String>()
        if (metadataNodes != null) {
            for (i in 0 until metadataNodes.length) {
                val n = metadataNodes.item(i) as? Element
                val name = n?.getAttribute("name")
                val value = n?.textContent
                if (!name.isNullOrBlank()) metaList.add("$name: ${value ?: ""}")
            }
        }
        val metaText = if (metaList.isNotEmpty()) metaList.joinToString(", ") else ""
        return "3MF parsed — objects: $objects, units: $unit" + if (metaText.isNotEmpty()) ", metadata: $metaText" else ""
    } catch (_: Throwable) {
        return null
    }
}

actual fun imageUrlForDisplay(url: String): String {
    val separator = if (url.contains("?")) "&" else "?"
    return "$url${separator}t=${Date().getTime().toLong()}"
}
